import { render, staticRenderFns } from "./ModalPageItemBemPermanente.vue?vue&type=template&id=96fdb4fa"
import script from "./ModalPageItemBemPermanente.vue?vue&type=script&lang=js"
export * from "./ModalPageItemBemPermanente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports